<ds-hybrid-field
  name="{{label}}"
  [id]="label"
  creatable
  placeholder="{{label}}"
  required="{{ required }}"
  label="{{ label }}"
  noresults="No results found"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [invalid]="invalid"
>

  <ds-menu-item *ngFor="let item of to.options" [value]="item.label">
    {{item.value}}
  </ds-menu-item>

</ds-hybrid-field>
